<template>
  <div class="has-campaignCuration-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-2 has-text-left has-text-primary has-text-weight-bold dm-sans">
            Dados Cadastrais
          </p>
        </div>
      </div>
      <div>
        <div class="columns">
          <div class="column is-full">
            <p class="is-size-4 has-text-left has-text-grey-secondary has-text-weight-bold">
              Responsável Legal
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Nome do representante</label>
              <div class="control">
                <input
                    v-validate="'required'"
                    required
                    name="legalGuardianName"
                    class="input"
                    type="text"
                    v-model="formData.legalGuardian.data.name"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Doc. RG do representante</label>
              <div class="control">
                <input
                    v-validate="'required'"
                    required
                    name="legalGuardianRgDocument"
                    class="input"
                    type="text"
                    v-model="formData.legalGuardian.data.rg_document"
                    v-mask="'##.###.###-X'"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Doc. CPF do representante</label>
              <div class="control">
                <input
                    v-validate="'required'"
                    required
                    name="legalGuardianCpfDocument"
                    class="input"
                    type="text"
                    v-model="formData.legalGuardian.data.cpf_document"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <div class="field-label">
                <label class="label has-text-left has-text-weight-light is-size-5 mb-label">Telefone do representante</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static has-text-grey-secondary">
                        +55
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input
                          v-validate="'required|min:14'"
                          required
                          name="legalGuardianPhoneNumber"
                          class="input"
                          type="tel" v-model="formData.legalGuardian.data.phone_number"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Email</label>
              <div class="control">
                <input
                  class="input"
                  v-validate="'required|email'"
                  name="legalGuardianEmail"
                  required
                  type="email"
                  v-model="formData.legalGuardian.data.email"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12 pt-6">
      <next-button
        @nextTab="nextTab"
        position="right"
        sizeClass="is-one-third"
      ></next-button>
    </div>
  </div>
</template>

<script>

import { mask } from 'vue-the-mask'
import NextButton from './NextButton'

export default {

  name: 'registration-data',

  components: {
    NextButton
  },

  directives: { mask },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      hasRecommendation: false
    }
  },

  methods: {
    // change() {
    //   this.hasRecommendation = !this.hasRecommendation
    // },
    nextTab() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$flashStorage.destroyAll()
          this.$emit('nextTab')
        } else {
          this.$flashStorage.destroyAll()
          this.flashError('Verifique se você preencheu todos os campos corretamente.');
        }
      })
    }
  }

}

</script>

<style lang="scss">
.mb-label {
  margin-bottom: 0.5em;
}
</style>